import React, { useState } from "react";
import "./togle.css";
import { FaCheck } from "react-icons/fa6";
import { MdClose } from "react-icons/md";

const BlockToggle = ({ checked, onChange }) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (loading) return; // agar already loading hai to dobara click kaam na kare

    setLoading(true);
    try {
      if (onChange) {
        await onChange(); // async response ka wait karega
      }
    } finally {
      setLoading(false); // response complete hone ke baad hi enable karega
    }
  };

  return (
    <div
      className={`toggle ${checked ? "unblocked" : "blocked"} ${
        loading ? "disabled" : ""
      }`}
      onClick={handleClick}
    >
      <div className="circle">{checked ? <FaCheck /> : <MdClose style={{fontSize: "1rem"}}/>}</div>
    </div>
  );
};

export default BlockToggle;

